import { render, staticRenderFns } from "./chronicle_user.vue?vue&type=template&id=a065f852&scoped=true"
import script from "./chronicle_user.vue?vue&type=script&lang=js"
export * from "./chronicle_user.vue?vue&type=script&lang=js"
import style0 from "./chronicle_user.vue?vue&type=style&index=0&id=a065f852&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a065f852",
  null
  
)

export default component.exports